import React from 'react';
import { Modal, Center } from '@mantine/core';
import ReactPlayer from 'react-player';
import { useResizeObserver } from '@mantine/hooks';

const VideoPlayerModal = ({ stateURL, stateTitle, stateShow, fnShow }) => {

    const [ref, rect] = useResizeObserver();

    return (
        <React.Fragment>
            <Modal
                opened={stateShow}
                onClose={fnShow}
                title={stateTitle}
                fullScreen={true}
            >
                <Center
                    ref={ref}
                    sx={{
                        width: '100%',
                        height: '100%'
                    }}
                >
                    <ReactPlayer
                        url={stateURL}
                        // width={data.modalWidth > data.modalHeight ? 'auto' : '100%'}
                        height={rect.width > rect.height ? (rect.height + 'px') : 'auto'}

                        loop={true}
                        playing={false}
                        controls={true}
                    />
                </Center>
            </Modal>
        </React.Fragment>
    );
}

export default VideoPlayerModal;